import styled from 'styled-components';
import { espacamento } from '../../styles/constants/sizes';

export const JanelaImpressao = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  width: 80%;
  max-width: 600px;
  flex-direction: column;
  max-height: 700px;
  overflow: auto;

  iframe {
    max-width: 100%;
    max-height: 80vh;
  }

  img {
    object-fit: contain;
    overflow: hidden;
    max-height: 75vh;
  }
`;

export const HeaderImpressao = styled.header`
  padding: 0 ${espacamento.pequeno}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerImpressao = styled.div`
  padding: ${espacamento.medio}px;
`;

export const InternaImpressao = styled.div`
  margin: ${espacamento.ultraPequeno}px;
  padding: ${espacamento.ultraPequeno}px ${espacamento.medio}px;
  border: 1px solid #dededd;
`;

export const SecaoImpressao = styled.div`
  background-color: #f0f0f0;
  padding: ${espacamento.ultraPequeno}px;
`;
